module.exports = __webpack_public_path__ + "img/d-1.55cfaffe.jpg";